<template>
    <layout-basic>
        <v-container fluid>
            <v-layout row wrap>
                <v-row style="margin-bottom: 44px">
                    <v-flex xs4 class="py-5">
                        
                    </v-flex>
                </v-row>
            </v-layout>
            <v-row>
                <v-col md="12">
                    <v-card flat>
                        <v-card-title>
                            <div class="flex-grow-1"></div>
                        </v-card-title>
                        <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
                        <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                        <v-data-table
                        :headers="headers"
                        :options.sync="options"
                        :server-items-length="serverItemsLength"
                        v-show="!loading"
                        :items="partners"
                        >
                            <template v-slot:item.id="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                        :id="item.id"
                                        :to="'/super-admin/partner/reports/' + item.user_id"
                                        outlined
                                        small
                                        color="secondary"
                                        >
                                            <v-icon small>fa-eye</v-icon>
                                        </v-btn>
                                    </template>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </layout-basic>
</template>

<script>
    import userAPI from "@/api/partner.js";
    import LayoutBasic from "@/layouts/SuperAdmin";
    import VueApexCharts from "vue-apexcharts";
    import partnerAPI from "@/api/partner.js";

    export default {
        name: "UsersReport",
        components: {
            LayoutBasic,
            apexchart: VueApexCharts
        },
        data() {
            return {
                headers: [
                    { text: "Partner", value: "company_name" },
                    { text: "First Name", value: "first_name" },
                    { text: "Surname", value: "last_name" },
                    { text: "Email", value: "email" },
                    { text: "Level", value: "level" },
                    { text: "Total Customers", value: "total_clients" },
                    { text: "Last Login", value: "last_login", sortable: false },
                    {
                        text: "",
                        value: "id",
                        sortable: false,
                        align: "end"
                    }
                ],
                partners: [],
                search: "",
                searchParams: "",
                pagination: {},
                options: {},
                loading: false,
                line: {},
            };
        },
        computed: {
            serverItemsLength: function() {
                return this.pagination.total;
            },
            itemsPerPage: function() {
                return this.pagination.per_page;
            },
            page: function() {
                return this.pagination.current_page;
            },
            params: function() {
                return this.$gf.getQueryString(this.options, this.serverItemsLength);
            },
            barSeries() {
                return [
                {
                    name: "Total Users",
                    data: this.bar.series
                }];
            },
            barChartOptions() {
                return {
                    plotOptions: {
                        bar: {
                            horizontal: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    tooltip: {
                        enabled: false
                    },
                    xaxis: {
                        categories: this.bar.categories,
                        tickAmount: 3,
                        labels: {
                            formatter: function(val) {
                                return val.toFixed(0);
                            }
                        }
                    }
                };
            },
            isTabletOrDesktop() {
                const width = this.$vuetify.breakpoint.width;
                return width >= 820;
            },
        },
        watch: {
            options: {
                handler() {
                    this.getPartners();
                    this.getReports();
                },
                deep: true
            }
        },
        methods: {
            getPartners() {
                this.loading = true;
                partnerAPI.getPartners(this.params + '&level=2', this.searchParams).then(resp => {
                    this.partners = resp.data.data;
                    this.pagination = resp.data.meta.pagination;
                    this.loading = false;
                });
            },
            resetSearch() {
                this.searchParams = "";
                this.getPartners();
            },
            applySearch() {
                this.searchParams = this.params + "&search=first_name:" + this.search + ";last_name:" + this.search;
                this.getPartners();
            },
            getReports() {
                userAPI.getPartnerCustomerReports(this.$store.getters.user.id).then(response => {
                    this.line = response.data.line;
                });
            }
        }
    };
</script>
